const indexItems = [
  { icon: 'ri-rocket-2-line', title: '科幻冒险', count: '1,280部', desc: '太空探索与未来世界' },
  { icon: 'ri-sword-line', title: '动作格斗', count: '2,150部', desc: '拳拳到肉的激爽体验' },
  { icon: 'ri-emotion-happy-line', title: '喜剧搞笑', count: '1,860部', desc: '释放压力的快乐源泉' },
  { icon: 'ri-heart-pulse-line', title: '悬疑推理', count: '1,420部', desc: '烧脑反转停不下来' },
  { icon: 'ri-hearts-line', title: '爱情浪漫', count: '1,650部', desc: '心动瞬间的温暖治愈' },
  { icon: 'ri-ghost-line', title: '恐怖惊悚', count: '890部', desc: '挑战胆量的极致体验' },
  { icon: 'ri-landscape-line', title: '动画动漫', count: '2,340部', desc: '全年龄段的视觉盛宴' },
  { icon: 'ri-history-line', title: '历史战争', count: '760部', desc: '史诗叙事的宏大篇章' },
];

export default function TopicIndex() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            片库索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            按类型快速浏览六六影院电影大全，找到你想看的每一部电影
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.title}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex flex-col items-center text-center bg-background-50 rounded-2xl p-5 md:p-6 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1 whitespace-nowrap">
                {item.title}
              </h3>
              <span className="text-xs text-primary-600 font-medium mb-1 whitespace-nowrap">
                {item.count}
              </span>
              <p className="text-xs text-foreground-500 whitespace-nowrap">
                {item.desc}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}